
import { useOnlineStatus } from "@/hooks/use-online-status";

type OfflineStatusProps = {
  isSyncing: boolean;
};

const OfflineStatus = ({ isSyncing }: OfflineStatusProps) => {
  const isOnline = useOnlineStatus();

  if (isOnline && !isSyncing) return null;

  return (
    <>
      {!isOnline && (
        <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4 mb-4">
          <p className="text-yellow-700">
            Du er offline. Dine ændringer vil blive synkroniseret når du får forbindelse igen.
          </p>
        </div>
      )}
      
      {isSyncing && (
        <div className="bg-blue-100 border-l-4 border-blue-500 p-4 mb-4">
          <p className="text-blue-700">
            Synkroniserer offline ændringer...
          </p>
        </div>
      )}
    </>
  );
};

export default OfflineStatus;
